module.exports = __webpack_public_path__ + "img/Frozen-food-in-plate.9f5158d2.jpg";